<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">

    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12">
            <m-card>
              <ng-container mCardHeaderTitle>
             Yeni Bileşik Ekle
              </ng-container>
              <ng-container mCardBody>
                <div class="row mb-2">
                 
                  <div class="col-md-12">
  <form [formGroup]="definitionForm">
   

      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>Adı</label>
            <input type="text" formControlName="name" class="form-control">
          </div>
        </div>
       
      </div>

      <div class="row">
        
        <div class="form-group">
          <label for="eventInput7">Özellikler <a class="btn btn-success" (click)="addProjectDutyPerson('')"> Ekle</a></label>

          <div class="row">
            <div class="col-md-4">
              Özellik
            </div>
            <div class="col-md-4">
              Metot
            </div>
            <div class="col-md-4">
             Değeri
            </div>
          </div>

          <div formArrayName="properties" *ngFor="let dep of getProjectDutyPerson().controls;let i=index">
         <div class="row mt-1" [formGroupName]="i">
           <div class="col-md-4">
              <input type="text" class="form-control" formControlName="property" name="property" id="{{i}}property">
           </div>
           <div class="col-md-4">
            <input type="text" class="form-control" formControlName="method" name="method" id="{{i}}method">
         </div>
           <div class="col-md-3">
            <input type="text" class="form-control" formControlName="value" name="value" id="{{i}}value">
          </div>
         
          <div class="col-md-1">
            <i class="la la-trash danger cursor mt-1" (click)="removeDuty(i)">

            </i>
          </div>
         </div>
        </div>
        </div>
       
      </div>


      <div class="row">
        
        <div class="form-group">
          <label for="eventInput7">Saflık <a class="btn btn-success" (click)="addPure()"> Ekle</a></label>
          <div class="row">
            <div class="col-md-4">
              SAFSIZLIK ADI
            </div>
            <div class="col-md-4">
              LİMİT
            </div>
            <div class="col-md-4">
              SPESİFİKASYON
            </div>
          </div>
          <div formArrayName="pureness" *ngFor="let dep of getPure().controls;let i=index">
         <div class="row mt-1" [formGroupName]="i">
           <div class="col-md-4">
              <input type="text" class="form-control" formControlName="name" name="name" id="{{i}}name">
           </div>
           <div class="col-md-4">
            <input type="text" class="form-control" formControlName="limit" name="limit" id="{{i}}limit">
         </div>
           <div class="col-md-3">
            <input type="text" class="form-control" formControlName="spesification" name="spesification" id="{{i}}spesification">
          </div>
         
          <div class="col-md-1">
            <i class="la la-trash danger cursor mt-1" (click)="removePure(i)">

            </i>
          </div>
         </div>
        </div>
        </div>
       
      </div>

<div class="row mt-3">
  <div class="col-md-12">
    <h3><b>Hammaddeler</b></h3>
  </div>
</div>

      <div class="row">
        <div class="col-md-3">
          <label>Hammadde Seçiniz</label>
          <ng-template #rt let-r="result" let-t="term">
           
            <ngb-highlight [result]="r.inciName" [term]="t"></ngb-highlight>
          </ng-template>
          <input
          id="typeahead-http"
          type="text"
          class="form-control"
          [class.is-invalid]="searchFailed"
          [(ngModel)]="madde"
          [ngbTypeahead]="search"
          [resultTemplate]="rt"
          placeholder="Hammadde ara"
          [inputFormatter]="formatter"
          [ngModelOptions]="{standalone: true}"
        />
        </div>
        <div class="col-md-3">
          <label>HM</label>
          <input type="text" class="form-control" [(ngModel)]="hm" [ngModelOptions]="{standalone: true}">
        </div>

       
        <div class="col-md-3" style="padding-top:25px;">
          <button class="btn btn-primary" (click)="addHammadde()">Ekle</button>
        </div>
      </div>







      <div class="row mt-3">
        <div class="col-md-12">
          <h5>Hammaddeler</h5>
          <table class="table table-bordered">
            <thead>
            <tr>
              <th>INCI Adı</th>
              <th>CAS</th>
              <th>EINECS/ELICS</th>
              <th>Fonksiyon</th>
              <th>% HM </th>
             
              <th></th>
            </tr>
          </thead>
            <tr *ngFor="let h of selectedHammaddeler;index as i">

             
              <td>{{h.material.inciName}}</td>
              <td>{{h.material.cas}}</td>
              <td>{{h.material.einecs}}</td>
              <td>{{h.material.function}}</td>
              <td>{{h.hm}}</td>
          
       <th><i class="la la-remove danger" style="cursor: pointer;" (click)="removemadde(i)"></i></th>
            </tr>
          </table>
        </div>
      </div>

      <button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="submitted">
        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
        Kaydet</button>


  
  </form>
</div>
                
</div>


</ng-container>
</m-card>
</div>
</div>
</section>
</div>
</div>
</div>
